import type { MailboxInfo } from "owa-client-types";
import type { SearchScenarioId } from "owa-search-store";
import type { SearchTab } from "owa-search-types/lib/types/SearchTab";
import { getStore } from "../store/store";
import getVisibleScopeTabs from "../utils/getVisibleScopeTabs";

export default function getActiveScopeTabForScenario(scenarioId: SearchScenarioId, mailboxInfo: MailboxInfo): SearchTab {
    const visibleTabs = getVisibleScopeTabs(scenarioId, mailboxInfo);
    const activeScopeTab = getStore().activeScopeTab;
    return activeScopeTab && visibleTabs.includes(activeScopeTab) ? activeScopeTab : visibleTabs[0];
}
